import React from 'react'
import { Row } from 'antd'
import { CustomCol } from 'src/components'
import { filterSections } from './options'
import { useTranslation } from 'next-i18next'

const AdminUsersListHeader: React.FC<{ usersLength: number }> = ({ usersLength }) => {
  const { t } = useTranslation()
  const sections = filterSections(t, usersLength)

  return (
    <Row>
      {sections.map((section, idx) => <CustomCol lg={section.lg} key={idx}>
        <>{section.children}</>
      </CustomCol>)}
    </Row>
  )
}

export default AdminUsersListHeader
